<template>
  <path
    d="M20.55 5.22018L19.16 3.54018C18.88 3.21018 18.47 3.00018 18 3.00018H6C5.53 3.00018 5.12 3.21018 4.85 3.55018L3.46 5.22018C3.17 5.57018 3 6.01018 3 6.50018V19.0002C3 20.1002 3.89 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V6.50018C21 6.01018 20.83 5.57018 20.55 5.22018ZM12.35 9.85018L17.5 15.0002H14V17.0002H10V15.0002H6.5L11.65 9.85018C11.84 9.66018 12.16 9.66018 12.35 9.85018ZM5.12 5.00018L5.94 4.00018H17.94L18.87 5.00018H5.12Z"
  />
</template>
